import { navigate } from 'gatsby';
import React, { useContext, FC, useEffect, Dispatch, SetStateAction, useState } from 'react';
import { ActivePropertyContext } from '../../context/ActivePropertyContext';
import { UiStateContext } from '../../context/UiStateContext';
import { useDataLayerPush } from '../../hooks/useDataLayerPush';
import { useGetPropertyByIdQuery } from '../../types/graphqlHelpers';
import { Kfh_PropertyTypeInterface } from '../../types/graphqlTypes';
import Blade from '../Blade';
import { Loader } from '../Loader';
import Spacer from '../Spacer';
import { DevelopmentPropertyCard } from './DevelopmentPropertyCard';
import { PropertyCard } from './PropertyCard';
import { getUrlParts } from '../../utils/getUrlParts';
import { getCleanPropertyDetails } from '../../utils/getCleanPropertyDetails';

interface PropertyCardBladeProps {
  property: Kfh_PropertyTypeInterface;
  propertyId: string | number | [string | number];
  isDevelopment?: boolean;
}
interface PropertyCardProps extends PropertyCardBladeProps {
  index: number;
  setFirstProperty: any;
}
const BladePropertyCard: FC<PropertyCardProps> = ({ propertyId, isDevelopment, setFirstProperty, index }) => {
  const { data, loading, called } = useGetPropertyByIdQuery({ variables: { id: propertyId } });
  const { dataLayerPush } = useDataLayerPush();
  const property = data?.properties?.property;
  console.log('property', property);
  useEffect(() => {
    if (called && !loading && property) {
      if (index === 0) {
        setFirstProperty(property);
      }
      dataLayerPush({
        event: 'blade action',
        bladeEvent: 'opened',
        bladeOpen: true,
        bladeBranchName: undefined,
        bladeEventID: 'propertyCard',
        bladePropertyDetails: getCleanPropertyDetails(property as Kfh_PropertyTypeInterface),
      });
    }
  }, [called, loading, property]);

  return (
    <>
      {loading && index === 0 && <Loader />}
      {called && !loading && property && (
        <>
          {isDevelopment && <DevelopmentPropertyCard property={property} />}
          {!isDevelopment && <PropertyCard property={property} vertical hideActions onWhiteBg />}
        </>
      )}
    </>
  );
};

export const PropertyCardBlade: FC<PropertyCardBladeProps> = ({ propertyId, isDevelopment, property }) => {
  const { setActiveProperty } = useContext(ActivePropertyContext);
  const { setActiveBlade } = useContext(UiStateContext);
  const [firstProperty, setFirstProperty] = useState<Kfh_PropertyTypeInterface | undefined>(undefined);
  const properties = propertyId && Array.isArray(propertyId) ? propertyId : [propertyId];

  // GA property click
  const { dataLayerPush } = useDataLayerPush();

  const propertyClick = {
    event: 'propertyClick',
    clickBladeID: false,
    propertyClickDetails: getCleanPropertyDetails(property || firstProperty),
    ...getUrlParts(firstProperty?.relativeUrl),
  };

  return (
    <>
      <Blade
        id="propertyCard"
        primaryButton={
          properties.length === 1
            ? {
                label: 'Property details',
                disableClickTracking: true,
                onClick: () => {
                  setActiveBlade(null);
        
                  dataLayerPush({
                    clickType: 'cta button',
                    ...propertyClick,
                  });

                  if (firstProperty) {
                    navigate(firstProperty?.relativeUrl);
                  }
                },
              }
            : undefined
        }
        secondaryButton={
          properties.length === 1
            ? {
                label: 'Arrange a viewing',
                onClick: () => {
                  if (firstProperty) {
                    setActiveProperty(firstProperty);
                  }
                  setActiveBlade('propertyArrangeAViewing');
                },
              }
            : undefined
        }
      >
        <Spacer>
          {properties.map((singlePropId, index) => (
            <BladePropertyCard
              key={singlePropId}
              propertyId={singlePropId}
              isDevelopment={isDevelopment}
              index={index}
              setFirstProperty={setFirstProperty}
            />
          ))}
        </Spacer>
      </Blade>
    </>
  );
};
